<template>
    <v-layout column>
        <v-toolbar class="text-h5 mb-3">
            <v-icon class="mr-3 success--text">check_circle</v-icon>
            Reservation Success!
        </v-toolbar>
        <reservation-info
            :currentStep="currentStep"
            :reservedUnit="reservedUnit"
        />
        <v-layout column class="mx-4">
            <v-textarea
                data-testid="reservation-note-textarea"
                class="reservation-note-textarea pt-2"
                v-model="note"
                filled
                label="Add Note (optional)"
                hint="When you are finished, click 'Add Note' to save this note to this tenant's account."
            />
            <v-btn
                data-testid="reservation-note-submit-btn"
                class="reservation-note-submit-btn primary mt-1 mx-0 mb-4"
                small
                :disabled="!note"
                :loading="loading"
                @click="addNote"
            >
                Add Note
            </v-btn>
            <v-flex class="subheading my-3">
                This reservation has been processed successfully. You may add a note for this reservation in the field
                above, click "Dismiss" to return to the application, or "Disposition" if the call has ended and you
                are ready to disposition.
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
import ReservationInfo from "@/components/reserve-unit/partials/ReservationInfo";

export default {
  props: ["currentStep", "reservedUnit", "waitingListId"],

  data() {
    return {
      loading: false,
      note: ""
    };
  },

  methods: {
    addNote() {
      this.loading = true;

      let payload = {
        facility_id: this.$route.params.facilityId,
        waiting_list_id: parseFloat(this.waitingListId),
        description: this.note
      };

      this.$store.dispatch("addNote", payload)
        .then(() => {
          this.loading = false;
          this.$store.dispatch("handleSuccess", "Reservation note added!");
          this.note = "";
        })
        .catch(err => {
          this.loading = false;
          this.$store.dispatch("handleError", err);
        });
    }
  },

  components: {
    ReservationInfo
  }
};
</script>
